<div class="p-grid">
    <form class="p-col-12 p-md-12 p-lg-6">
      <h2 class="mu-fileForm-title">{{ 'context.massive.cfdi.fileUploadForm.title' | translate }}</h2>
      <p-fileUpload
        #fileUploadControl
        id="mu-file-create"
        chooseLabel="{{ 'context.massive.cfdi.fileUploadForm.loadFileButton' | translate }}"
        name="myfile[]"
        [accept]="fileFormatsAllowedToUpload"
        [auto]="true"
        [customUpload]="true"
        (onRemove)="handleFilePending()"
        (onSelect)="handleFilePending()"
        (uploadHandler)="eventLoadExcelFile(fileUploadControl, $event)"
      >
        <ng-template let-file pTemplate="file">
          <div>
            <i class="mu-icon-sticky-note" aria-hidden="true"></i>
            {{ file.name }}
          </div>
        </ng-template>
      </p-fileUpload>
      <div class="p-grid">
        <app-mu-button
          id="fileUpload-button-spacing"
          label="{{ 'context.massive.cfdi.fileUploadForm.cancelButton' | translate }}"
          [disabled]="!this.fileUploaded"
          class="mu-button-outline p-col-12 p-md-5 p-lg-4 p-my-0"
          (click)="cancelLoad(fileUploadControl)"
        >
        </app-mu-button>
        <app-mu-button
          label="{{ 'context.massive.cfdi.fileUploadForm.confirmButton' | translate }}"
          class="p-col-12 p-md-5 p-lg-4 p-my-0"
          [flagList]="flagList"
          [flag]="uploadFileFlag"
          [disabled]="!this.fileUploaded"
        >
        </app-mu-button>
      </div>
    </form>
  </div>

